import { QueryClient } from '@tanstack/react-query';

/**
 * Module-level singleton so vanilla code (the tag system's profile store,
 * future analytics/marketing tag integrations) can read the same server-state
 * cache the React tree uses. `AppProviders` wires this into
 * `QueryClientProvider` by default and accepts a `queryClientOverride` for
 * unit tests that need an isolated client.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Base freshness; per-query `queryOptions` factories (core/query/*.queries.ts)
      // override per data volatility. Cross-screen coherence after a write comes
      // from the `reconcile.ts` invalidation policy, not from staleTime or focus
      // refetching — so window focus is not load-bearing for freshness.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: { retry: false },
  },
});
